import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import './Globals.css'

const IECPagination = ({
  storeIecInfoData,
  storeIECPaginationData,
  changePaginationLimit,
  prevPage,
  nextPage,
}: any) => {
  const { limit, offset, selectedLimit } = storeIECPaginationData;

  return (
    <div className="footer">
      <p style={{ fontWeight: "600", fontSize: "14px", margin: "0" }}>
        No. of Records: {storeIecInfoData.count === undefined ? 0 : `${(limit > storeIecInfoData.count) ? storeIecInfoData.count : limit}/${storeIecInfoData.count}`}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >

        <FormControl>
          <RadioGroup
            row
            value={selectedLimit}
            onChange={(event: any) => {
              changePaginationLimit(Number(event.target.value));
            }}
          >
            <FormControlLabel
              value="25"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#5C79AA",
                    "&.Mui-checked": {
                      color: "#5C79AA",
                    },
                  }}
                />
              }
              label="25"
            />
            <FormControlLabel
              value="50"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#5C79AA",
                    "&.Mui-checked": {
                      color: "#5C79AA",
                    },
                  }}
                />
              }
              label="50"
            />
            <FormControlLabel
              value="100"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#5C79AA",
                    "&.Mui-checked": {
                      color: "#5C79AA",
                    },
                  }}
                />
              }
              label="100"
            />
          </RadioGroup>
        </FormControl>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <label style={{ fontWeight: "550", fontSize: "14px" }}>
            Pagination :
          </label>
          <img
            src={require("../assets/img/prev.png")}
            alt=""
            style={{ cursor: "pointer", marginRight: "5px", marginLeft: "5px" }}
            onClick={() => {
              prevPage(limit);
            }}
          />

          <label style={{ fontWeight: "550", fontSize: "14px" }}>
            {offset} - {offset + selectedLimit}
          </label>
          <img
            src={require("../assets/img/next.svg").default}
            alt=""
            style={{ cursor: "pointer", marginRight: "5px", marginLeft: "5px" }}
            onClick={() => {
              nextPage(limit);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default IECPagination;